<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/parameterList' }">参数</el-breadcrumb-item>
                <el-breadcrumb-item>参数{{type == '1' ? '编辑' : '新增',}}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submitDetailsData('ruleDetailsForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form
                        :model="ruleForm"
                        :rules="rules"
                        ref="ruleDetailsForm"
                        :label-position="labelPosition"
                        class="details_temp2023"
                    >
                        <el-form-item label="code：" prop="code">
                            <el-input
                                v-model="ruleForm.code"
                                class="flex_item_text"
                                size="mini"
                                readonly="readonly"
                                v-if="type == 1"
                            ></el-input>
                            <el-input v-model="ruleForm.code" size="mini" placeholder="请输入代码" v-else clearable></el-input>
                        </el-form-item>
                        <el-form-item label="名称：" prop="name">
                            <el-input
                                v-model="ruleForm.name"
                                class="flex_item_text"
                                size="mini"
                                readonly="readonly"
                                v-if="type == 1"
                            ></el-input>
                            <el-input v-model="ruleForm.name" size="mini" placeholder="请输入名称" v-else clearable></el-input>
                        </el-form-item>
                        <el-form-item label="值：" prop="value">
                            <el-input v-model="ruleForm.value" size="mini" placeholder="请输入值" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="备注：" prop="remark">
                            <el-input v-model="ruleForm.remark" size="mini" placeholder="请输入备注" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="创建人：" prop="created_by" v-if="type == 1">
                            <div class="read_only">
                                {{ ruleForm.created_by ? ruleForm.created_by : '' }}
                            </div>
                        </el-form-item>
                        <el-form-item label="上次修改人：" prop="updated_by" v-if="type == 1">
                            <div class="read_only">
                                {{ ruleForm.updated_by ? ruleForm.updated_by : '' }} 
                            </div>
                        </el-form-item>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
export default {
    name: 'parameterEdit',
    data() {
        return {
            btnLoading: false,
            rid: '',
            title: '', //新增或编辑
            type: '', //1  编辑 2 新增
            activeNames: ['1'],
            labelPosition: 'right',
            //基本信息内表单验证
            ruleForm: {
                code: '',
                name: '',
                number_value: '',
                remark: ''
            },
            rules: {
                value: [{ required: true, message: '请输入值', trigger: 'blur' }],
                code: [{ required: true, message: '请输入代码', trigger: 'blur' }],
                name: [{ required: true, message: '请输入名称', trigger: 'blur' }]
            },
            btnTitle: ''
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.rid = this.$route.query.id;
    },
    mounted() {
        if (this.type == 1 || this.type == 5) {
            this.getDetails(); //获取详情
        } else {
            this.ruleForm = {};
        }
    },
    methods: {
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/parameterList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getDetails() {
            let params = {
                rid: this.rid
            };
            this.$api
                .parameterDetail(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.ruleForm = res.data;
                    }
                })
                .catch((error) => {});
        },
        //提交新增/编辑修改
        submitDetailsData(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    if (this.type == 1) {
                        this.submitEditData(); //修改
                    } else {
                        this.submitAddData(); //新增
                    }
                } else {
                    return false;
                }
            });
        },
        //提交修改
        submitEditData() {
            let params = {
                value: this.ruleForm.value,
                remark: this.ruleForm.remark ? this.ruleForm.remark : '',
                code: this.ruleForm.code,
                name: this.ruleForm.name,
                rid: this.rid
            };
            this.$api
                .parameterUpdate(params)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '修改成功！',
                            type: 'success'
                        });
                        this.cancel();
                    }
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        },
        //提交新增
        submitAddData() {
            let params = {
                value: this.ruleForm.value,
                remark: this.ruleForm.remark ? this.ruleForm.remark : '',
                code: this.ruleForm.code,
                name: this.ruleForm.name
            };
            this.$api
                .parameterInsert(params)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '新增成功！',
                            type: 'success'
                        });
                        this.cancel();
                    }
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>